import {device} from './device'
let winDev = device()
/**
 * 友盟统计
 */
function YOUMONG (w, d, s, q, i) {
  return new Promise(function (resolve){
    // 注入sdk
    w[q] = w[q] || [];
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    j.async = true;
    j.id = 'beacon-aplus';
    j.src = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js';
    f.parentNode.insertBefore(j, f);
    resolve()
  })
}
function getStoreUserKey(){
   let localUserInfo = localStorage.getItem('localUserInfo') || '{}'
   try{
     localUserInfo = JSON.parse(localUserInfo)
    }catch(err){
      localUserInfo = {}
    }
    // userId: userInfo.userId,
    // mobile: userInfo.mobile,
    // partnerId: userInfo.partnerId,
    // rankName: userInfo.rankName,
    // partnerName: userInfo.partnerName
   return function( key ){
      if(localUserInfo && localUserInfo[key]){
        return localUserInfo[key] + ''
      }else{
        return ''
      }
   }
}
function appendCommonParams(params) {
  let _paramIndex = 0
  if(params.action === 'aplus.record'){
    _paramIndex = 2
  }else if(params.action === 'aplus.sendPV'){
    _paramIndex = 1
  }
  if(_paramIndex === 0) {
    return params;
  }
  const userInfoFn = getStoreUserKey()
  let newParams = {
    ...winDev,
    isH5: 'false',
    ip: window.returnCitySN?.cip || '',
    Current_URL: location.href ? location.href.split('?')[0] : '',
    Referrer: document.referrer || '',
    //Pre_URL: location.origin +'' +window.history?.state?.back || '',
    userId: userInfoFn('userId'),
    userMobile: userInfoFn('mobile'),
    Partner_Id: userInfoFn('partnerId'),
    Rank_Name: userInfoFn('rankName'),
    Partner_Name: userInfoFn('partnerName'),
    Browser_Version: winDev && winDev['version'],
    Browser_Name: winDev && winDev['name'],
    Operation_System: winDev && winDev['os'],
    Screen_Height: window.screen.height+'',
    Screen_Width: window.screen.width+'',
    UserName: userInfoFn('userName'),
    NowTime: userInfoFn('date')
  }
  if(window.history?.state && window.history?.state.back !==null &&typeof window.history?.state.back !== 'undefined'){
    newParams.Pre_URL = location.origin +''+ window.history?.state.back
  }
  Object.keys(newParams).forEach(key=>{
    if(typeof newParams[key] === 'undefined' ||  newParams[key] === null || newParams[key] ==''){
      delete newParams[key]
    }
  })
  let _ret = Object.assign({},params)
  //  arguments: ['Action_user_device', 'CLK', Object.assign({}, {pvPath: location.href}, device())]
  if(_ret.action === 'aplus.record' || _ret.action === 'aplus.sendPV'){
    let _tempArgs = Object.assign({},newParams,_ret.arguments[_paramIndex]||[])
    // _ret = Object.assign({},params,{
    //   arguments:
    // })
    _ret.arguments = params.arguments.slice(0,_paramIndex).concat(_tempArgs)
  }
  return _ret
}
function init_ym_point(){
// 对外暴露api
  winDev = device()
  window.$ztDataAction = {
    device: winDev,
    push: function (params = {action: '', arguments: []}){
      const aplus_queue = window.aplus_queue || window.aplus || {};
      // 这里新增通用参数
      try{
        let paramsMerge = appendCommonParams(params)
         //let paramsMerge = params
          //if(params.options && params.options.debugger){
          // console.log('paramsMerge before====', params.action )
          // console.log('paramsMerge after=====',paramsMerge)
          // delete paramsMerge.options
          // }

          // if(location.origin.includes("//www.z-trip.cn") || params.action === 'aplus.setMetaInfo'){
            aplus_queue.push(paramsMerge);
          // }



        //  if(process.env.NODE_ENV === 'development'){
        //   if(location.origin.includes('.z-trip.cn') || location.origin.includes('//localhost') || params.action === 'aplus.setMetaInfo'){
        //     // console.log('埋点上报=====',paramsMerge)
        //     aplus_queue.push(paramsMerge);
        //   }
        //  }else{
        //   if(location.origin.includes('//m.z-trip.cn') || params.action === 'aplus.setMetaInfo'){
        //     aplus_queue.push(paramsMerge);
        //   }
        //  }
      }catch(err){
        console.error('appendCommonParams ERROR', err)
      }
    }
  };
  // 集成应用的appKey
  window.$ztDataAction.push({
    action: 'aplus.setMetaInfo',
    arguments: ['appKey', '615292f514e22b6a4f0fe7bb']
  });
  // 设置手动Pv
  window.$ztDataAction.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN']
  });
  /*//是否开启调试模式
  window.$ztDataAction.push({
    action: 'aplus.setMetaInfo',
    arguments: ['DEBUG', true]
  });*/
  // 设备分析
  if(localStorage.getItem('userId')){
    window.$ztDataAction.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_user_id', localStorage.getItem('userId')]
    });
  }
  window.$ztDataAction.push({
    action: 'aplus.record',
    arguments: ['Action_user_device', 'CLK', Object.assign({}, {pvPath: location.href}, winDev)]
  });
  // 首次加载-刷新页面
  window.$ztDataAction.push({
    action: 'aplus.sendPV',
    arguments: [{is_auto: false}, Object.assign({}, {pvPath: location.href}, winDev)]
  });
  // 路由变化上报Pv
  function routeChange(e) {
    if(!e.state){
      return
    }
    window.$ztDataAction.push({
      action: 'aplus.sendPV',
      arguments: [{is_auto: false}, Object.assign({}, {pvPath: e.state.current}, winDev) ]
    });
  }
  window.addEventListener('popstate', routeChange);
}
// 性能
function YUEYING(c, i, e, b){
  const h = i.createElement("script");
  const f = i.getElementsByTagName("script")[0];
  h.id = 'dd_watch'
  h.type = "text/javascript";
  h.crossorigin = true;
  h.onload = function () {
    // 上报限制
    const allow = (location.origin.includes('www.z-trip.cn'))
    // 钉钉监控
    // c[b] || (c[b] = new c.wpkReporter({
    //   bid: "dta_2_38110",
    //   spa: true,
    //   ignoreScriptError: true,
    //   beforeSend: function(logData) {
    //     if(allow) return true
    //     return false
    //   },
    //   plugins:[
    //     [
    //       wpkglobalerrorPlugin,
    //       { // 配置参数
    //         resErr: true,
    //         resErrFilter: (event) => {
    //           return true
    //         },
    //         jsErr: true,
    //         jsErrFilter: (event) => {
    //           return false
    //         }
    //       }
    //     ]
    //   ]
    // }));
    // c[b].installAll()
    // 岳鹰监控
    // c['yyWpk'] || (c['yyWpk'] = new c.wpkReporter({
    //   bid: "o3umg4o9-i41vpt5w",
    //   spa: true,
    //   ignoreScriptError: true,
    //   debug: false,
    //   sampleRate: 0.8,
    //   uid: () => {
    //     const wpk_uuid = document.cookie.substr(document.cookie.indexOf('__wpkreporterwid_'),54).split("=")[1]
    //     return localStorage.getItem('userId') || wpk_uuid
    //   },
    //   beforeSend: function(logData) {
    //     if(allow) return true
    //     return false
    //   },
    //   plugins:[
    //     [
    //       wpkglobalerrorPlugin,
    //       { // 配置参数
    //         resErr: true,
    //         resErrFilter: (event) => {
    //           if(event.target.nodeName==='IMG'){
    //             if(event.target.currentSrc.includes('.z-trip.cn')){
    //               return true
    //             }
    //             return false
    //           }
    //           return true
    //         },
    //         jsErr: true,
    //         jsErrFilter: (event) => {
    //           return true
    //         }
    //       }
    //     ]
    //   ]
    // }));
    // c['yyWpk'].installAll()
  };
  f.parentNode.insertBefore(h, f);
  h.src = e
}
export async function youMongEvent() {
  if ((location.origin.includes('www.z-trip.cn') && (window.$ZConfig.getVal('ENV') === 'master' || window.$ZConfig.getVal('ENV') === 'green'))) {
    const url = window.location.pathname
    if (window.localStorage.getItem('dstore_corpId')) {
      // 性能
      await YUEYING(window, document, "https://g.alicdn.com/woodpeckerx/jssdk??wpkReporter.js,plugins/globalerror.js", "__wpk")
    }
  }
  // 友盟
  await YOUMONG(window, document, 'script', 'aplus_queue', '203467608')
    .then(() => {
      init_ym_point()
    })
  // window.$ztDataAction = {
  //   push: () =>{}
  // }
}
